var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhyChooseIcon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.32,
    height: 28,
    viewBox: "0 0 26.32 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_119198",
    "data-name": "Path 119198",
    d: "M4.7.13a.169.169,0,0,0-.329,0C3.654,5.892,0,7.078,0,11.083a4.534,4.534,0,0,0,9.067,0C9.067,7.078,5.412,5.892,4.7.13Zm17.254,0a.169.169,0,0,0-.329,0c-.714,5.761-4.368,6.948-4.368,10.952a4.533,4.533,0,0,0,9.066,0C26.32,7.078,22.667,5.892,21.952.13ZM13,12.569c-.715,5.762-4.369,6.948-4.369,10.952a4.533,4.533,0,0,0,9.066,0c0-4-3.654-5.19-4.369-10.952A.169.169,0,0,0,13,12.569Z",
    transform: "translate(0 0)",
    fill: "#073c00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyChooseIcon4);
export default __webpack_public_path__ + "static/media/whyChoose-icon4.d92ebdaff1391dcdd071ba43ee2fc1fd.svg";
export { ForwardRef as ReactComponent };